import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

import config from 'lib/config'

Bugsnag?.start({
  apiKey: config.BUGSNAG_API_KEY,
  appVersion: window?.globals?.version || 'v3.15.9',
  plugins: [new BugsnagPluginReact()],
  releaseStage: config.ENV,
  // Bugsnag's own console logger prints '[bugsnag] Loaded!' on every start, once
  // per test file. `logger: null` falls back to its internal no-op logger; keep
  // the default everywhere else so real Bugsnag notices still surface in dev.
  ...(config.IS_TEST_MODE ? { logger: null } : {}),
})

export const BugsnagErrorBoundary =
  Bugsnag.getPlugin('react').createErrorBoundary(React)
